var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.29167 0C1.02602 0 0 1.02602 0 2.29167V4.16423H16.6634V5.41423H0V11.036C0 12.3016 1.02602 13.3276 2.29167 13.3276H14.3717C15.6374 13.3276 16.6634 12.3016 16.6634 11.036V4.2025C16.6635 3.56396 16.6636 2.92511 16.6631 2.28633C16.6621 1.02199 15.6361 0 14.3733 0H2.29167ZM3.95833 7.08089C3.61316 7.08089 3.33333 7.36073 3.33333 7.70589C3.33333 8.05106 3.61316 8.33089 3.95833 8.33089H6.45833C6.8035 8.33089 7.08333 8.05106 7.08333 7.70589C7.08333 7.36073 6.8035 7.08089 6.45833 7.08089H3.95833Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.87f5c638bf8b99064e889c8ffe978eca.svg";
export { ForwardRef as ReactComponent };